export const FETCH_EXPERIENCE_REQUEST = "FETCH_EXPERIENCE_REQUEST";
export const FETCH_EXPERIENCE_SUCCESS = "FETCH_EXPERIENCE_SUCCESS";
export const FETCH_EXPERIENCE_FAILURE = "FETCH_EXPERIENCE_FAILURE";
export const FETCH_EXPERIENCE_DETAILS = "FETCH_EXPERIENCE_DETAILS";
export const FETCH_EXPERIENCE_TERMS = "FETCH_EXPERIENCE_TERMS";
export const FETCH_EXPERIENCE_IMAGES = "FETCH_EXPERIENCE_IMAGES";
export const FETCH_EXPERIENCE_DETAILS_SUCCESS = "FETCH_EXPERIENCE_DETAILS_SUCCESS";
export const FETCH_IMAGES_REQUEST = 'FETCH_IMAGES_REQUEST'
export const FETCH_IMAGES_FAILURE = 'FETCH_IMAGES_FAILURE'